export const RESET_STORE = 'app/RESET_STORE';
